import React from 'react';
import { Button } from "../../../elements/Button";
import { Modal } from "../../../elements/Modal";
import { Form } from "../../../collections/Form";
import { TextInput } from "../../../inputs/TextInput";
import { InputGroup } from "../../../collections/InputGroup";
import { TextArea } from "../../../inputs/TextArea";
import { Dropdown } from "../../../inputs/Dropdown";
import { RatingInput } from "../../../inputs/RatingInput";
import { Checkbox } from "../../../inputs/Checkbox";
import { getPrivacyConsentLabel } from "../../../../utils/get-privacy-consent-label";
import { EMAIL_MAX_CHARACTERS, COMMENT_MAX_CHARACTERS, NAME_MAX_CHARACTERS, TITLE_MAX_CHARACTERS, LOCATION_MAX_CHARACTERS } from "../constants";
export var getModalFormMarkup = function getModalFormMarkup(_ref, isShowingPlaceholder) {
  var botProtectionMessage = _ref.botProtectionMessage,
      commentInputLabel = _ref.commentInputLabel,
      emailInputLabel = _ref.emailInputLabel,
      errorMessage = _ref.errorMessage,
      formHeadingText = _ref.formHeadingText,
      guestTypeInputLabel = _ref.guestTypeInputLabel,
      guestTypeOptions = _ref.guestTypeOptions,
      isBotProtected = _ref.isBotProtected,
      isPrivacyConsentRequired = _ref.isPrivacyConsentRequired,
      locationInputLabel = _ref.locationInputLabel,
      monthInputLabel = _ref.monthInputLabel,
      monthOptions = _ref.monthOptions,
      nameInputLabel = _ref.nameInputLabel,
      onSubmit = _ref.onSubmit,
      ratingInputLabel = _ref.ratingInputLabel,
      submitButtonText = _ref.submitButtonText,
      successMessage = _ref.successMessage,
      titleInputLabel = _ref.titleInputLabel,
      validation = _ref.validation,
      yearInputLabel = _ref.yearInputLabel,
      yearOptions = _ref.yearOptions,
      privacyConsentLabelText = _ref.privacyConsentLabelText,
      privacyConsentLabelLinkUrl = _ref.privacyConsentLabelLinkUrl,
      privacyConsentLabelLinkText = _ref.privacyConsentLabelLinkText;
  return React.createElement(Modal, {
    isClosingOnDimmerClick: false,
    trigger: React.createElement(Button, {
      isCompact: true,
      isDisabled: isShowingPlaceholder,
      isPositionedRight: true,
      isRounded: true,
      size: "medium"
    }, submitButtonText)
  }, React.createElement(Form, {
    autoComplete: "off",
    errorMessage: errorMessage,
    headingText: formHeadingText,
    onSubmit: onSubmit,
    submitButtonText: submitButtonText,
    successMessage: successMessage,
    validation: validation
  }, React.createElement(RatingInput, {
    label: ratingInputLabel,
    name: "rating"
  }), React.createElement(TextInput, {
    autoComplete: "name",
    label: nameInputLabel,
    maxCharacters: NAME_MAX_CHARACTERS,
    name: "name"
  }), React.createElement(InputGroup, null, React.createElement(TextInput, {
    autoComplete: "email",
    label: emailInputLabel,
    maxCharacters: EMAIL_MAX_CHARACTERS,
    name: "email"
  }), React.createElement(TextInput, {
    autoComplete: "country-name",
    label: locationInputLabel,
    maxCharacters: LOCATION_MAX_CHARACTERS,
    name: "location"
  })), React.createElement(InputGroup, null, React.createElement(Dropdown, {
    label: monthInputLabel,
    name: "month",
    options: monthOptions
  }), React.createElement(Dropdown, {
    label: yearInputLabel,
    name: "year",
    options: yearOptions
  })), React.createElement(InputGroup, null, React.createElement(Dropdown, {
    label: guestTypeInputLabel,
    name: "guestType",
    options: guestTypeOptions
  })), React.createElement(TextInput, {
    label: titleInputLabel,
    maxCharacters: TITLE_MAX_CHARACTERS,
    name: "title"
  }), React.createElement(TextArea, {
    label: commentInputLabel,
    maxCharacters: COMMENT_MAX_CHARACTERS,
    name: "comments"
  }), isBotProtected && botProtectionMessage, isPrivacyConsentRequired && React.createElement(Checkbox, {
    label: getPrivacyConsentLabel(privacyConsentLabelText, privacyConsentLabelLinkUrl, privacyConsentLabelLinkText),
    name: "privacyConsent"
  })));
};